import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Navigation from './components/admin/Navigation';
import Footer from './components/admin/Footer';
import Dashboard from './components/admin/Dashboard';
import AddBanner from './components/admin/AddBanner';
import NewsForm from './components/admin/NewsForm';
import NewsList from './components/admin/NewsList';
import AdsForm from './components/admin/AdsForm';
import AdsList from './components/admin/AdsList';
import VideoForm from './components/admin/VideoForm';
import VideoList from './components/admin/VideoList';
import Homepage from './components/frontend/Homepage';
import NewsDetails from './components/frontend/NewsDetails';
import NewsDetailsKPTV from './components/frontend/NewsDetailsKPTV';
import BengaluruAllNewsDetails from './components/frontend/BengaluruAllNewsDetails';
import KarnatakaAllNewsDetails from './components/frontend/KarnatakaAllNewsDetails';
import NationalAllNewsDetails from './components/frontend/NationalAllNewsDetails';
import KPTVAllNewsDetails from './components/frontend/KPTVAllNewsDetails';
import AboutUs from './components/frontend/AboutUs';
import ContactUs from './components/frontend/ContactUs';
import Terms from './components/frontend/Terms';
import PrivacyPolicy from './components/frontend/PrivacyPolicy';
import InterViews from './components/frontend/InterViews';
import AdvisoryBoard from './components/frontend/AdvisoryBoard';
import EditorialTeam from './components/frontend/EditorialTeam';
import EntertainmentNews from './components/frontend/EntertainmentNews';
import LifeStyleNews from './components/frontend/LifeStyleNews';

import BmrclAllNews from './components/frontend/BmrclAllNews';
import BbmpAllNews from './components/frontend/BbmpAllNews';
import BdaAllNews from './components/frontend/BdaAllNews';

import HealthNews from './components/frontend/HealthNews';

import SportNews from './components/frontend/SportNews';

import WorldNews from './components/frontend/WorldNews';

import TechNews from './components/frontend/TechNews';

import FoodNews from './components/frontend/FoodNews';

import EnvNews from './components/frontend/EnvNews';



import Profile from './components/admin/Profile';
import ChangePassword from './components/admin/ChangePassword';

import './App.css';

import Login from './services/Login';
import PrivateRoute from './services/PrivateRoute';




// ✅ Wrapper for protected layout
const AdminLayout = ({ children }) => (
  <div className="App">
    <Navigation />
    {children}
    <Footer />
  </div>
);

function App() {
  return (
    <Routes>

      {/* Public Routes */}
      <Route path="/" element={<Homepage />} />
      <Route path="/homepage" element={<Homepage />} />
      <Route path="/news-details" element={<NewsDetails />} />
      <Route path="/news-details-kptv" element={<NewsDetailsKPTV />} />
      <Route path="/bengaluru-allnews-details" element={<BengaluruAllNewsDetails />} />
      <Route path="/karnataka-allnews-details" element={<KarnatakaAllNewsDetails />} />
      <Route path="/national-allnews-details" element={<NationalAllNewsDetails />} />
      <Route path="/venkatadri-allnews-details" element={<KPTVAllNewsDetails />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/interviews" element={<InterViews />} />
      <Route path="/advisory" element={<AdvisoryBoard />} />
      <Route path="/our-team" element={<EditorialTeam />} />
      <Route path="/login" element={<Login />} />
      <Route path="/entertainment" element={<EntertainmentNews />} />
      <Route path="/life-style" element={<LifeStyleNews />} />
      <Route path="/metrobmrcl" element={<BmrclAllNews />} />
      <Route path="/metrobbmp" element={<BbmpAllNews />} />
      <Route path="/metrobbda" element={<BdaAllNews />} />
      <Route path="/health" element={<HealthNews />} />

      <Route path="/sport" element={<SportNews />} />

      <Route path="/world" element={<WorldNews />} />

      <Route path="/tech" element={<TechNews />} />

      <Route path="/food" element={<FoodNews />} />

      <Route path="/environment" element={<EnvNews />} />


      <Route
        path="/user/profile"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Profile />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/user/change-password"
        element={
          <PrivateRoute>
            <AdminLayout>
              <ChangePassword />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      {/* Protected Routes */}
      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/banners"
        element={
          <PrivateRoute>
            <AdminLayout>
              <AddBanner />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/news"
        element={
          <PrivateRoute>
            <AdminLayout>
              <NewsForm />
            </AdminLayout>
          </PrivateRoute>
        }
      />


      <Route
        path="/admin/news-list"
        element={
          <PrivateRoute>
            <AdminLayout>
              <NewsList />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/ads"
        element={
          <PrivateRoute>
            <AdminLayout>
              <AdsForm />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/ads-list"
        element={
          <PrivateRoute>
            <AdminLayout>
              <AdsList />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/videos"
        element={
          <PrivateRoute>
            <AdminLayout>
              <VideoForm />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/videos-list"
        element={
          <PrivateRoute>
            <AdminLayout>
              <VideoList />
            </AdminLayout>
          </PrivateRoute>
        }
      />






    </Routes>
  );
}

export default App;